export const HOME = {
  emergentLink: "home-emergent-link",
};

export const NAV = {
  logo: "nav-logo",
  linkHome: "nav-link-home",
  linkServices: "nav-link-services",
  linkAbout: "nav-link-about",
  linkContact: "nav-link-contact",
  cta: "nav-cta",
  menuToggle: "nav-menu-toggle",
};

export const HERO = {
  scrollCue: "hero-scroll-cue",
  ctaPrimary: "hero-cta-primary",
  ctaSecondary: "hero-cta-secondary",
};

export const SERVICES = {
  chapter: (n) => `service-chapter-${n}`,
  ctaContact: "services-cta-contact",
};

export const CONTACT = {
  form: "contact-form",
  name: "contact-name",
  company: "contact-company",
  email: "contact-email",
  phone: "contact-phone",
  service: "contact-service",
  message: "contact-message",
  submit: "contact-submit",
  success: "contact-success",
  error: "contact-error",
};

export const ADMIN = {
  table: "admin-submissions-table",
  refresh: "admin-refresh",
  row: (id) => `admin-row-${id}`,
  empty: "admin-empty",
  logout: "admin-logout",
  loginForm: "admin-login-form",
  loginEmail: "admin-login-email",
  loginPassword: "admin-login-password",
  loginSubmit: "admin-login-submit",
  loginError: "admin-login-error",
  changePwOpen: "admin-change-pw-open",
  changePwCurrent: "admin-change-pw-current",
  changePwNew: "admin-change-pw-new",
  changePwConfirm: "admin-change-pw-confirm",
  changePwSubmit: "admin-change-pw-submit",
  changePwClose: "admin-change-pw-close",
  changePwError: "admin-change-pw-error",
  changePwSuccess: "admin-change-pw-success",
};

export const FOOTER = {
  wordmark: "footer-wordmark",
  emailLink: "footer-email",
  phoneLink: "footer-phone",
};

export const JOBS = {
  page: "jobs-page",
  search: "jobs-search",
  filterIndustry: (v) => `jobs-filter-industry-${v}`,
  filterTech: (v) => `jobs-filter-tech-${v}`,
  filterSeniority: (v) => `jobs-filter-seniority-${v}`,
  filterRemote: (v) => `jobs-filter-remote-${v}`,
  clear: "jobs-clear-filters",
  card: (id) => `jobs-card-${id}`,
  applyBtn: (id) => `jobs-apply-${id}`,
  count: "jobs-count",
  empty: "jobs-empty",
};

export const CV = {
  headerBtn: "cv-header-btn",
  modal: "cv-modal",
  dropzone: "cv-dropzone",
  fileInput: "cv-file-input",
  parsing: "cv-parsing",
  parsed: "cv-parsed",
  parseError: "cv-parse-error",
  editProfile: "cv-edit-profile",
  quickSave: "cv-quick-save",
  close: "cv-modal-close",
};

export const APPLY = {
  form: "apply-form",
  name: "apply-name",
  email: "apply-email",
  phone: "apply-phone",
  headline: "apply-headline",
  role: "apply-current-role",
  company: "apply-current-company",
  years: "apply-years",
  linkedin: "apply-linkedin",
  github: "apply-github",
  skills: "apply-skills",
  skillsInput: "apply-skills-input",
  skillRemove: (s) => `apply-skill-remove-${s}`,
  summary: "apply-summary",
  submit: "apply-submit",
  success: "apply-success",
  error: "apply-error",
  cvDrop: "apply-cv-drop",
  jobBadge: "apply-job-badge",
};

export const SAVED = {
  openBtn: "saved-search-open",
  modal: "saved-search-modal",
  close: "saved-search-close",
  name: "saved-search-name",
  email: "saved-search-email",
  label: "saved-search-label",
  submit: "saved-search-submit",
  success: "saved-search-success",
  error: "saved-search-error",
  chip: "saved-search-chip",
  chipDelete: (id) => `saved-search-chip-delete-${id}`,
};

export const CLIENT = {
  loginForm: "client-login-form",
  loginEmail: "client-login-email",
  loginPassword: "client-login-password",
  loginSubmit: "client-login-submit",
  loginError: "client-login-error",
  dashboard: "client-dashboard",
  jobCard: (id) => `client-job-${id}`,
  appRow: (id) => `client-app-${id}`,
  empty: "client-empty",
  logout: "client-logout",
};

export const ADMIN_CLIENTS = {
  tab: "admin-tab-clients",
  list: "admin-clients-list",
  row: (id) => `admin-client-row-${id}`,
  create: "admin-clients-create",
  editorEmail: "admin-client-editor-email",
  editorName: "admin-client-editor-name",
  editorCompany: "admin-client-editor-company",
  editorPassword: "admin-client-editor-password",
  editorSave: "admin-client-editor-save",
  editorCancel: "admin-client-editor-cancel",
  editorError: "admin-client-editor-error",
  editorJobToggle: (id) => `admin-client-editor-job-${id}`,
  delete: (id) => `admin-client-delete-${id}`,
  edit: (id) => `admin-client-edit-${id}`,
};

export const ADMIN_BLOG = {
  tab: "admin-tab-blog",
  list: "admin-blog-list",
  row: (id) => `admin-blog-row-${id}`,
  create: "admin-blog-create",
  editorTitle: "admin-blog-editor-title",
  editorExcerpt: "admin-blog-editor-excerpt",
  editorBody: "admin-blog-editor-body",
  editorTags: "admin-blog-editor-tags",
  editorCover: "admin-blog-editor-cover",
  editorAuthor: "admin-blog-editor-author",
  editorPublished: "admin-blog-editor-published",
  editorSave: "admin-blog-editor-save",
  editorCancel: "admin-blog-editor-cancel",
  editorError: "admin-blog-editor-error",
  edit: (id) => `admin-blog-edit-${id}`,
  delete: (id) => `admin-blog-delete-${id}`,
};

export const ADMIN_TABS = {
  enquiries: "admin-tab-enquiries",
  clients: "admin-tab-clients",
  blog: "admin-tab-blog",
};
